import { ApiReferenceReact } from "@scalar/api-reference-react";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import "@scalar/api-reference-react/style.css";
import { useAcquireToken } from "~/hooks/useAcquireToken";

export const Route = createFileRoute("/_authenticated/docs/aviary")({
  component: AviaryDocs,
});

function AviaryDocs() {
  const acquireToken = useAcquireToken();

  const { data: content, isLoading } = useQuery({
    queryKey: ["aviary", "openapi.json"],
    queryFn: async () => {
      const token = await acquireToken();
      const response = await fetch("/api/aviary/openapi.json", {
        headers: { Authorization: `Bearer ${token.accessToken}` },
      });
      return await response.text();
    },
  });

  const { data: token } = useQuery({
    queryKey: ["auth", "token"],
    queryFn: async () => {
      return await acquireToken();
    },
  });

  return (
    <ApiReferenceReact
      configuration={{
        content,
        isLoading,
        authentication: token && {
          preferredSecurityScheme: "bearerAuth",
          securitySchemes: {
            bearerAuth: {
              token: token.accessToken,
            },
          },
        },
      }}
    />
  );
}
